export const structuredAnalysisTypes = Object.freeze({
  QofE: 'quality-of-earnings',
  NWC: 'net-working-capital',
  DDL: 'debt-debt-like',
});
